(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Load Lottie library for animations
  if (typeof lottie === 'undefined') {
    const lottieScript = document.createElement('script');
    lottieScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
    document.head.appendChild(lottieScript);
  }
  
  // Order confirmation animation data will be loaded dynamically
  window.orderConfirmAnimationPath = '/Order Confirm.json';
  
  // Fallback: Add to cart animation data (embedded)
  window.addToCartAnimationData = {"v":"4.8.0","meta":{"g":"LottieFiles AE 3.1.1","a":"Sadjad","k":"Cart Add","d":"Uicon Animated Icons","tc":""},"fr":30,"ip":0,"op":79,"w":128,"h":128,"nm":"Cart-Add_lottie","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Layer 1 Outlines","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[64.009,56.5,0],"ix":2},"a":{"a":0,"k":[64.009,56.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-3.881,0],[0,0]],"o":[[0,0],[0.676,3.821],[0,0],[0,0]],"v":[[-22.051,15.5],[-20.92,21.894],[-13.042,28.5],[26.249,28.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":1,"k":[{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":17,"s":[{"i":[[0,0],[0,0],[-0.426,4.074],[0,0],[5.06,-0.538],[0,0]],"o":[[0,0],[4.096,0],[0,0],[0.529,-5.062],[0,0],[0,0]],"v":[[-22.051,15.5],[27.876,15.5],[35.833,8.331],[37.722,-9.776],[28.921,-18.562],[24.633,-18.106]],"c":false}]},{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":31,"s":[{"i":[[0,0],[0,0],[-0.426,4.074],[0,0],[5.06,-0.538],[0,0]],"o":[[0,0],[4.096,0],[0,0],[0.529,-5.062],[0,0],[0,0]],"v":[[-22.051,15.5],[27.876,15.5],[35.833,8.331],[37.722,-9.776],[28.921,-18.562],[5.429,-16.299]],"c":false}]},{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":47,"s":[{"i":[[0,0],[0,0],[-0.426,4.074],[0,0],[5.06,-0.538],[0,0]],"o":[[0,0],[4.096,0],[0,0],[0.529,-5.062],[0,0],[0,0]],"v":[[-22.051,15.5],[27.876,15.5],[35.833,8.331],[37.722,-9.776],[28.921,-18.562],[5.429,-16.299]],"c":false}]},{"t":60,"s":[{"i":[[0,0],[0,0],[-0.426,4.074],[0,0],[5.06,-0.538],[0,0]],"o":[[0,0],[4.096,0],[0,0],[0.529,-5.062],[0,0],[0,0]],"v":[[-22.051,15.5],[27.876,15.5],[35.833,8.331],[37.722,-9.776],[28.921,-18.562],[24.633,-18.106]],"c":false}]}],"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":1,"k":[{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":17,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[-11.6,-15.106]],"c":false}]},{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":31,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[5.478,-16.213]],"c":false}]},{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":47,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[5.478,-16.213]],"c":false}]},{"t":60,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[-11.6,-15.106]],"c":false}]}],"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[4.04,0],[0,0]],"o":[[0,0],[-0.493,-4.01],[0,0],[0,0]],"v":[[-25.716,-13.606],[-26.684,-21.477],[-34.624,-28.5],[-38.251,-28.5]],"c":false},"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ind":4,"ty":"sh","ix":5,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[-22.051,15.5]],"c":false},"ix":2},"nm":"Path 5","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[64.251,56.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":7,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Layer 2 Outlines","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":11,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":25,"s":[90]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":54,"s":[-90]},{"t":67,"s":[0]}],"ix":10},"p":{"a":0,"k":[69.5,35.5,0],"ix":2},"a":{"a":0,"k":[69.5,35.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[69.5,26],[69.5,45]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[60,35.5],[79,35.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":11,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":25,"s":[0]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":54,"s":[0]},{"t":67,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":3,"nm":"Null 1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[64,64,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.8,0.8,0.8],"y":[0,0,0]},"t":26,"s":[100,100,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.8,0.8,0.8],"y":[0,0,0]},"t":39,"s":[80,80,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.8,0.8,0.8],"y":[0,0,0]},"t":54,"s":[90,90,100]},{"t":67,"s":[100,100,100]}],"ix":6}},"ao":0,"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"cart Outlines 2","parent":4,"td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":11,"s":[0]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":25,"s":[-15]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":38,"s":[-15]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":54,"s":[13]},{"t":67,"s":[0]}],"ix":10},"p":{"a":0,"k":[-17.5,21.25,0],"ix":2},"a":{"a":0,"k":[46.5,85.25,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-3.881,0],[0,0],[0,0]],"o":[[0,0],[0.676,3.821],[0,0],[0,0],[0,0]],"v":[[-22.055,15.5],[-20.924,21.894],[-13.047,28.5],[26.245,28.5],[28.494,16.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[4.04,0],[0,0]],"o":[[0,0],[-0.493,-4.01],[0,0],[0,0]],"v":[[-25.721,-13.606],[-26.689,-21.477],[-34.629,-28.5],[-38.256,-28.5]],"c":false},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.721,-13.606],[-22.055,15.5]],"c":false},"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":38,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.034,-18.703],[37.732,-9.906],[35.829,8.331],[27.872,15.5],[-22.055,15.5]],"c":false}]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":51,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.927,-14.548],[38.625,-5.751],[36.722,12.486],[28.765,19.655],[-22.055,15.5]],"c":false}]},{"t":65,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.034,-18.703],[37.732,-9.906],[35.829,8.331],[27.872,15.5],[-22.055,15.5]],"c":false}]}],"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"tr","p":{"a":0,"k":[64.256,56.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":6,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 1","tt":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.3,"y":1},"o":{"x":0.7,"y":0},"t":36,"s":[66.5,-21.5,0],"to":[0,14,0],"ti":[0,-14,0]},{"t":45,"s":[66.5,62.5,0]}],"ix":2},"a":{"a":0,"k":[-5.5,-20.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[26,34],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":8,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-5.5,-20.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":-2,"op":46,"st":-2,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"circle Outlines 2","parent":4,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-14,34,0],"ix":2},"a":{"a":0,"k":[50,98,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.393,0],[0,-2.393],[2.393,0],[0,2.393]],"o":[[2.393,0],[0,2.393],[-2.393,0],[0,-2.393]],"v":[[0,-4.332],[4.332,0],[0,4.332],[-4.332,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[50,98],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"circle Outlines","parent":4,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":11,"s":[22,34,0],"to":[0,-2.167,0],"ti":[0,0,0]},{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":25,"s":[22,21,0],"to":[0,0,0],"ti":[0,-2.167,0]},{"t":31,"s":[22,34,0]}],"ix":2},"a":{"a":0,"k":[86,98,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":31,"s":[{"i":[[-2.393,0],[0,-2.393],[2.393,0],[0,2.393]],"o":[[2.393,0],[0,2.393],[-2.393,0],[0,-2.393]],"v":[[0,-4.332],[4.332,0],[0,4.332],[-4.332,0]],"c":true}]},{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":38,"s":[{"i":[[-2.393,0],[0,-1.438],[2.393,0],[0,1.438]],"o":[[2.393,0],[0,1.438],[-2.393,0],[0,-1.438]],"v":[[0,-0.875],[4.332,1.729],[0,4.332],[-4.332,1.729]],"c":true}]},{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":47,"s":[{"i":[[-2.393,0],[0,-2.393],[2.393,0],[0,2.393]],"o":[[2.393,0],[0,2.393],[-2.393,0],[0,-2.393]],"v":[[0,-4.332],[4.332,0],[0,4.332],[-4.332,0]],"c":true}]},{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":55,"s":[{"i":[[-2.393,0],[0,-1.438],[2.393,0],[0,1.438]],"o":[[2.393,0],[0,1.438],[-2.393,0],[0,-1.438]],"v":[[0,-0.875],[4.332,1.729],[0,4.332],[-4.332,1.729]],"c":true}]},{"t":64,"s":[{"i":[[-2.393,0],[0,-2.393],[2.393,0],[0,2.393]],"o":[[2.393,0],[0,2.393],[-2.393,0],[0,-2.393]],"v":[[0,-4.332],[4.332,0],[0,4.332],[-4.332,0]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[86,98],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"cart Outlines","parent":4,"sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":11,"s":[0]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":25,"s":[-15]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":38,"s":[-15]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":54,"s":[13]},{"t":67,"s":[0]}],"ix":10},"p":{"a":0,"k":[-17.5,21.25,0],"ix":2},"a":{"a":0,"k":[46.5,85.25,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-3.881,0],[0,0]],"o":[[0,0],[0.676,3.821],[0,0],[0,0]],"v":[[-22.055,15.5],[-20.924,21.894],[-13.047,28.5],[26.245,28.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[4.04,0],[0,0]],"o":[[0,0],[-0.493,-4.01],[0,0],[0,0]],"v":[[-25.721,-13.606],[-26.689,-21.477],[-34.629,-28.5],[-38.256,-28.5]],"c":false},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.721,-13.606],[-22.055,15.5]],"c":false},"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":38,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.034,-18.703],[37.732,-9.906],[35.829,8.331],[27.872,15.5],[-22.055,15.5]],"c":false}]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":51,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.927,-14.548],[38.625,-5.751],[36.722,12.486],[28.765,19.655],[-22.055,15.5]],"c":false}]},{"t":65,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.034,-18.703],[37.732,-9.906],[35.829,8.331],[27.872,15.5],[-22.055,15.5]],"c":false}]}],"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[64.256,56.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":6,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":17,"s":[86.5]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":31,"s":[100]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":47,"s":[100]},{"t":60,"s":[86.5]}],"ix":2},"o":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":17,"s":[-139]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":31,"s":[-159]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":47,"s":[-159]},{"t":60,"s":[-139]}],"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":241,"st":0,"bm":0}],"markers":[]};
  
  // Force sort dropdown options to be visible
  document.addEventListener('DOMContentLoaded', function() {
    const sortSelects = document.querySelectorAll('select[name="sort_by"], .sort-by select, .collection-sorting select, select.collection-sort, select[data-sort], #SortBy');
    
    sortSelects.forEach(function(select) {
      // Style the select element
      select.style.fontWeight = 'bold';
      select.style.color = '#000';
      
      // Style all options
      const options = select.querySelectorAll('option');
      options.forEach(function(option) {
        option.style.color = '#000';
        option.style.backgroundColor = '#fff';
        
        // Make selected option bold
        if (option.selected) {
          option.style.fontWeight = 'bold';
          option.style.backgroundColor = '#e6e6e6';
        } else {
          option.style.fontWeight = 'normal';
        }
      });
      
      // Update on change
      select.addEventListener('change', function() {
        options.forEach(function(option) {
          if (option.selected) {
            option.style.fontWeight = 'bold';
            option.style.backgroundColor = '#e6e6e6';
          } else {
            option.style.fontWeight = 'normal';
            option.style.backgroundColor = '#fff';
          }
        });
      });
    });
  });
  
  // ============================================
  // VARIANT POPUP FUNCTIONALITY - Global Scope
  // ============================================
  
  window.selectedVariantId = null;
  window.currentProduct = null;
  
  // Open variant popup
  window.openVariantPopup = function(productHandle) {
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        window.currentProduct = product;
        
        // Check if product has only one variant (no options to choose)
        if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
          // Add directly to cart without showing popup
          addToCartDirectly(product.variants[0].id);
          return;
        }
        
        // Show popup for products with variants
        displayProductInPopup(product);
        document.getElementById('variantPopup').style.display = 'flex';
        document.body.style.overflow = 'hidden';
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        showQuickNotification('Αδυναμία φόρτωσης προϊόντος. Παρακαλώ δοκιμάστε ξανά.', 'error');
      });
  };
  
  // Add to cart directly without popup (AJAX)
  function addToCartDirectly(variantId) {
    // Show loading notification
    showQuickNotification('Προσθήκη στο καλάθι...', 'loading');
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Show success notification
      showQuickNotification('Προστέθηκε στο καλάθι με επιτυχία! ✓', 'success');
      
      // Update cart count using AJAX
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateCartCountDisplay(cart.item_count);
        });
      
      // Trigger cart update events
      if (typeof Shopify !== 'undefined' && typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate();
      }
      
      if (window.theme && typeof window.theme.updateCart === 'function') {
        window.theme.updateCart();
      }
      
      // Trigger custom event for cart drawer
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Open the side cart panel immediately
      openSideCart();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      showQuickNotification('Αδυναμία προσθήκης στο καλάθι. Παρακαλώ δοκιμάστε ξανά.', 'error');
    });
  }
  
  // Update cart count display
  function updateCartCountDisplay(count) {
    // Try multiple common cart count selectors
    const cartCountSelectors = [
      '.cart-count',
      '.cart-counter',
      '.cart__count',
      '.header__cart-count',
      '[data-cart-count]',
      '.js-cart-count',
      '#cart-count',
      '.cartcount'
    ];
    
    cartCountSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.textContent = count;
        if (count > 0) {
          element.classList.add('active');
        }
      });
    });
  }
  
  // Open side cart panel
  function openSideCart() {
    // Try multiple common cart drawer/panel selectors
    const cartPanelSelectors = [
      '.mini-cart',
      '.mini_cart',
      '.cart-drawer',
      '.cart-panel',
      '.side-cart',
      '.ajax-cart',
      '#mini-cart',
      '#cart-drawer',
      '[data-cart-drawer]',
      '.js-cart-drawer',
      '.popup-ajax-cart'
    ];
    
    // Try to find and open the cart panel
    let cartOpened = false;
    
    cartPanelSelectors.forEach(selector => {
      const cartElement = document.querySelector(selector);
      if (cartElement) {
        // Add common "open" classes
        cartElement.classList.add('open', 'active', 'is-open', 'show');
        cartElement.style.display = 'block';
        cartElement.style.visibility = 'visible';
        cartOpened = true;
      }
    });
    
    // Also add class to body to indicate cart is open
    document.body.classList.add('cart-open', 'cart-drawer-open');
    
    // If cart wasn't found, try triggering click on cart icon to open it
    if (!cartOpened) {
      const cartIcons = document.querySelectorAll('.cart-icon, .header-cart, [data-cart-trigger], .js-cart-trigger, .cart-trigger');
      cartIcons.forEach(icon => {
        if (icon) {
          icon.click();
          cartOpened = true;
        }
      });
    }
    
    // Reload cart content via AJAX
    fetch('/cart?view=ajax')
      .then(response => response.text())
      .then(html => {
        const cartContainers = document.querySelectorAll('.js-cart-inner, .cart-items, [data-cart-items]');
        if (cartContainers.length > 0) {
          // Parse the HTML to extract cart content
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartContent = doc.querySelector('.js-cart-inner');
          
          if (newCartContent) {
            cartContainers.forEach(container => {
              container.outerHTML = newCartContent.outerHTML;
            });
          }
        }
      })
      .catch(error => {
        console.log('Cart content refresh skipped:', error);
        // If AJAX cart view doesn't exist, just trigger a page-level cart update
        if (typeof window.theme !== 'undefined' && typeof window.theme.cartDrawer !== 'undefined') {
          window.theme.cartDrawer.open();
        }
      });
  }
  
  // Show quick notification with Lottie animation
  function showQuickNotification(message, type) {
    // Remove existing notification
    const existing = document.querySelector('.quick-notification');
    if (existing) {
      existing.remove();
    }
    
    // For loading/success, show the white circle with Lottie animation
    if (type === 'loading' || type === 'success') {
      const notification = document.createElement('div');
      notification.className = `quick-notification quick-notification-${type}`;
      
      // Create white circle container
      const circleContainer = document.createElement('div');
      circleContainer.style.cssText = `
        width: 100px;
        height: 100px;
        background: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 24px rgba(0,0,0,0.15);
      `;
      
      // Create Lottie animation container
      const lottieContainer = document.createElement('div');
      lottieContainer.id = 'add-to-cart-animation-' + Date.now();
      lottieContainer.style.cssText = `
        width: 80px;
        height: 80px;
      `;
      
      circleContainer.appendChild(lottieContainer);
      notification.appendChild(circleContainer);
      
      // Add styles to notification
      notification.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
        animation: scaleIn 0.3s ease;
      `;
      
      document.body.appendChild(notification);
      
      // Wait for Lottie library to load, then play animation
      const playAnimation = () => {
        if (typeof lottie !== 'undefined') {
          // Load Order Confirm animation
          fetch(window.orderConfirmAnimationPath || '/Order Confirm.json')
            .then(response => response.json())
            .then(data => {
              const anim = lottie.loadAnimation({
                container: lottieContainer,
                renderer: 'svg',
                loop: type === 'loading',
                autoplay: true,
                animationData: data
              });
            })
            .catch(error => {
              console.log('Loading Order Confirm animation failed, using fallback');
              // Fallback to embedded add to cart animation
              const anim = lottie.loadAnimation({
                container: lottieContainer,
                renderer: 'svg',
                loop: type === 'loading',
                autoplay: true,
                animationData: window.addToCartAnimationData
              });
            });
        } else {
          // Fallback if Lottie is not available
          lottieContainer.innerHTML = '<div style="font-size: 40px; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">✓</div>';
        }
      };
      
      // Check if Lottie is loaded, otherwise wait a bit
      if (typeof lottie !== 'undefined') {
        playAnimation();
      } else {
        setTimeout(playAnimation, 100);
      }
      
      // Auto remove after animation completes (success only)
      if (type === 'success') {
        setTimeout(() => {
          notification.style.animation = 'scaleOut 0.3s ease';
          setTimeout(() => notification.remove(), 300);
        }, 3500); // Order confirm animation duration ~3 seconds
      }
    } else {
      // For error messages, show regular notification
      const notification = document.createElement('div');
      notification.className = `quick-notification quick-notification-${type}`;
      notification.textContent = message;
      
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #dc3545;
        color: #fff;
        padding: 15px 25px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        z-index: 10000;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        animation: slideInRight 0.3s ease;
        font-family: 'Manrope', sans-serif;
      `;
      
      document.body.appendChild(notification);
      
      setTimeout(() => {
        notification.style.animation = 'slideOutRight 0.3s ease';
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    }
  }
  
  // Close variant popup
  window.closeVariantPopup = function() {
    document.getElementById('variantPopup').style.display = 'none';
    document.body.style.overflow = '';
    window.selectedVariantId = null;
    window.currentProduct = null;
    document.getElementById('variantMessage').style.display = 'none';
  };
  
  // Display product in popup
  function displayProductInPopup(product) {
    const productImage = document.getElementById('variantProductImage');
    if (product.featured_image) {
      productImage.src = product.featured_image;
      productImage.alt = product.title;
    }
    
    document.getElementById('variantProductTitle').textContent = product.title;
    const price = (product.price / 100).toFixed(2);
    document.getElementById('variantProductPrice').textContent = `€${price}`;
    
    displayVariantOptions(product);
  }
  
  // Display variant options
  function displayVariantOptions(product) {
    const container = document.getElementById('variantOptionsContainer');
    container.innerHTML = '';
    
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      window.selectedVariantId = product.variants[0].id;
      return;
    }
    
    const options = product.options;
    
    // Get available values for each option based on variant availability
    const availableOptionValues = {};
    
    product.variants.forEach(variant => {
      if (variant.available) {
        if (variant.option1) {
          if (!availableOptionValues[options[0].name]) {
            availableOptionValues[options[0].name] = new Set();
          }
          availableOptionValues[options[0].name].add(variant.option1);
        }
        if (variant.option2 && options[1]) {
          if (!availableOptionValues[options[1].name]) {
            availableOptionValues[options[1].name] = new Set();
          }
          availableOptionValues[options[1].name].add(variant.option2);
        }
        if (variant.option3 && options[2]) {
          if (!availableOptionValues[options[2].name]) {
            availableOptionValues[options[2].name] = new Set();
          }
          availableOptionValues[options[2].name].add(variant.option3);
        }
      }
    });
    
    options.forEach((option, optionIndex) => {
      if (option.name === 'Title') return;
      
      const optionGroup = document.createElement('div');
      optionGroup.className = 'variant-option-group';
      
      const label = document.createElement('label');
      label.className = 'variant-option-label';
      label.textContent = option.name + ':';
      optionGroup.appendChild(label);
      
      const valuesContainer = document.createElement('div');
      valuesContainer.className = 'variant-option-values';
      
      // Only show available option values
      const availableValues = availableOptionValues[option.name] || new Set();
      
      option.values.forEach(value => {
        // Only create button if this value is available in stock
        if (availableValues.has(value)) {
          const valueButton = document.createElement('button');
          valueButton.className = 'variant-option-value';
          valueButton.textContent = value;
          valueButton.dataset.option = optionIndex + 1;
          valueButton.dataset.value = value;
          
          valueButton.onclick = function() {
            selectVariantOption(this, optionIndex + 1);
          };
          
          valuesContainer.appendChild(valueButton);
        }
      });
      
      // Only add the option group if there are available values
      if (valuesContainer.children.length > 0) {
        optionGroup.appendChild(valuesContainer);
        container.appendChild(optionGroup);
      }
    });
    
    if (product.variants.length > 0) {
      const firstAvailableVariant = product.variants.find(v => v.available);
      if (firstAvailableVariant) {
        preselectVariantOptions(firstAvailableVariant);
      }
    }
  }
  
  // Preselect variant options
  function preselectVariantOptions(variant) {
    const optionButtons = document.querySelectorAll('.variant-option-value');
    
    if (variant.option1) {
      optionButtons.forEach(btn => {
        if (btn.dataset.option === '1' && btn.dataset.value === variant.option1) {
          btn.classList.add('selected');
        }
      });
    }
    if (variant.option2) {
      optionButtons.forEach(btn => {
        if (btn.dataset.option === '2' && btn.dataset.value === variant.option2) {
          btn.classList.add('selected');
        }
      });
    }
    if (variant.option3) {
      optionButtons.forEach(btn => {
        if (btn.dataset.option === '3' && btn.dataset.value === variant.option3) {
          btn.classList.add('selected');
        }
      });
    }
    
    window.selectedVariantId = variant.id;
    updateAddToCartButton();
  }
  
  // Select variant option
  function selectVariantOption(button, optionNumber) {
    const allOptionsInGroup = document.querySelectorAll(`.variant-option-value[data-option="${optionNumber}"]`);
    allOptionsInGroup.forEach(btn => btn.classList.remove('selected'));
    
    button.classList.add('selected');
    findMatchingVariant();
  }
  
  // Find matching variant
  function findMatchingVariant() {
    if (!window.currentProduct) return;
    
    const selectedOptions = {};
    const selectedButtons = document.querySelectorAll('.variant-option-value.selected');
    
    selectedButtons.forEach(btn => {
      selectedOptions['option' + btn.dataset.option] = btn.dataset.value;
    });
    
    const matchingVariant = window.currentProduct.variants.find(variant => {
      let matches = true;
      if (selectedOptions.option1 && variant.option1 !== selectedOptions.option1) matches = false;
      if (selectedOptions.option2 && variant.option2 !== selectedOptions.option2) matches = false;
      if (selectedOptions.option3 && variant.option3 !== selectedOptions.option3) matches = false;
      return matches;
    });
    
    if (matchingVariant) {
      window.selectedVariantId = matchingVariant.id;
      
      const price = (matchingVariant.price / 100).toFixed(2);
      document.getElementById('variantProductPrice').textContent = `€${price}`;
      
      if (matchingVariant.featured_image) {
        document.getElementById('variantProductImage').src = matchingVariant.featured_image.src;
      }
      
      updateAddToCartButton(matchingVariant.available);
    } else {
      window.selectedVariantId = null;
      updateAddToCartButton(false);
    }
  }
  
  // Update add to cart button
  function updateAddToCartButton(available = true) {
    const button = document.getElementById('addToCartBtn');
    if (window.selectedVariantId && available) {
      button.disabled = false;
      button.textContent = 'Προσθήκη στο Καλάθι';
    } else if (!available) {
      button.disabled = true;
      button.textContent = 'Εξαντλημένο';
    } else {
      button.disabled = true;
      button.textContent = 'Επιλέξτε Μέγεθος';
    }
  }
  
  // Add to cart from popup
  window.addSelectedVariantToCart = function() {
    if (!window.selectedVariantId) {
      showVariantMessage('Παρακαλώ επιλέξτε όλες τις επιλογές', 'error');
      return;
    }
    
    const button = document.getElementById('addToCartBtn');
    button.disabled = true;
    button.textContent = 'Προσθήκη...';
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: window.selectedVariantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      showVariantMessage('Προστέθηκε στο καλάθι με επιτυχία! ✓', 'success');
      
      // Update cart count using AJAX
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateCartCountDisplay(cart.item_count);
        });
      
      // Trigger cart update events
      if (typeof Shopify !== 'undefined' && typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate();
      }
      
      if (window.theme && typeof window.theme.updateCart === 'function') {
        window.theme.updateCart();
      }
      
      // Trigger custom event for cart drawer
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Open the side cart panel immediately
      setTimeout(() => {
        openSideCart();
        window.closeVariantPopup();
      }, 1000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      showVariantMessage('Αδυναμία προσθήκης στο καλάθι. Παρακαλώ δοκιμάστε ξανά.', 'error');
      button.disabled = false;
      button.textContent = 'Προσθήκη στο Καλάθι';
    });
  };
  
  // Show message
  function showVariantMessage(message, type) {
    const messageDiv = document.getElementById('variantMessage');
    messageDiv.textContent = message;
    messageDiv.className = 'variant-message ' + type;
    messageDiv.style.display = 'block';
    
    if (type === 'error') {
      setTimeout(() => {
        messageDiv.style.display = 'none';
      }, 3000);
    }
  }
  
  // Event listeners
  document.addEventListener('click', function(event) {
    const popup = document.getElementById('variantPopup');
    if (event.target === popup) {
      window.closeVariantPopup();
    }
  });
  
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const popup = document.getElementById('variantPopup');
      if (popup && popup.style.display === 'flex') {
        window.closeVariantPopup();
      }
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iframe-video"]) return;
  try {
    
	const postervideo = document.querySelector('[id^="Deferred-Poster-"]');
    postervideo.addEventListener('click', function(){
        if (!this.getAttribute('loaded')) {
          const content = document.createElement('div');
          content.appendChild(this.nextElementSibling.content.firstElementChild.cloneNode(true));
          this.parentElement.setAttribute('loaded', true);
          this.parentElement.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        }
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  // Load Lottie library for animations
  if (typeof lottie === 'undefined') {
    const lottieScript = document.createElement('script');
    lottieScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
    document.head.appendChild(lottieScript);
  }
  
  // Order confirmation animation data will be loaded dynamically
  window.orderConfirmAnimationPath = '/Order Confirm.json';
  
  // Fallback: Add to cart animation data (embedded)
  window.addToCartAnimationData = {"v":"4.8.0","meta":{"g":"LottieFiles AE 3.1.1","a":"Sadjad","k":"Cart Add","d":"Uicon Animated Icons","tc":""},"fr":30,"ip":0,"op":79,"w":128,"h":128,"nm":"Cart-Add_lottie","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Layer 1 Outlines","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[64.009,56.5,0],"ix":2},"a":{"a":0,"k":[64.009,56.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-3.881,0],[0,0]],"o":[[0,0],[0.676,3.821],[0,0],[0,0]],"v":[[-22.051,15.5],[-20.92,21.894],[-13.042,28.5],[26.249,28.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":1,"k":[{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":17,"s":[{"i":[[0,0],[0,0],[-0.426,4.074],[0,0],[5.06,-0.538],[0,0]],"o":[[0,0],[4.096,0],[0,0],[0.529,-5.062],[0,0],[0,0]],"v":[[-22.051,15.5],[27.876,15.5],[35.833,8.331],[37.722,-9.776],[28.921,-18.562],[24.633,-18.106]],"c":false}]},{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":31,"s":[{"i":[[0,0],[0,0],[-0.426,4.074],[0,0],[5.06,-0.538],[0,0]],"o":[[0,0],[4.096,0],[0,0],[0.529,-5.062],[0,0],[0,0]],"v":[[-22.051,15.5],[27.876,15.5],[35.833,8.331],[37.722,-9.776],[28.921,-18.562],[5.429,-16.299]],"c":false}]},{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":47,"s":[{"i":[[0,0],[0,0],[-0.426,4.074],[0,0],[5.06,-0.538],[0,0]],"o":[[0,0],[4.096,0],[0,0],[0.529,-5.062],[0,0],[0,0]],"v":[[-22.051,15.5],[27.876,15.5],[35.833,8.331],[37.722,-9.776],[28.921,-18.562],[5.429,-16.299]],"c":false}]},{"t":60,"s":[{"i":[[0,0],[0,0],[-0.426,4.074],[0,0],[5.06,-0.538],[0,0]],"o":[[0,0],[4.096,0],[0,0],[0.529,-5.062],[0,0],[0,0]],"v":[[-22.051,15.5],[27.876,15.5],[35.833,8.331],[37.722,-9.776],[28.921,-18.562],[24.633,-18.106]],"c":false}]}],"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":1,"k":[{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":17,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[-11.6,-15.106]],"c":false}]},{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":31,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[5.478,-16.213]],"c":false}]},{"i":{"x":0.2,"y":1},"o":{"x":0.8,"y":0},"t":47,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[5.478,-16.213]],"c":false}]},{"t":60,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[-11.6,-15.106]],"c":false}]}],"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[4.04,0],[0,0]],"o":[[0,0],[-0.493,-4.01],[0,0],[0,0]],"v":[[-25.716,-13.606],[-26.684,-21.477],[-34.624,-28.5],[-38.251,-28.5]],"c":false},"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ind":4,"ty":"sh","ix":5,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.716,-13.606],[-22.051,15.5]],"c":false},"ix":2},"nm":"Path 5","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[64.251,56.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":7,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Layer 2 Outlines","parent":9,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":11,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":25,"s":[90]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":54,"s":[-90]},{"t":67,"s":[0]}],"ix":10},"p":{"a":0,"k":[69.5,35.5,0],"ix":2},"a":{"a":0,"k":[69.5,35.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[69.5,26],[69.5,45]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[60,35.5],[79,35.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":11,"s":[100]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":25,"s":[0]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":54,"s":[0]},{"t":67,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":3,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":3,"nm":"Null 1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[64,64,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.8,0.8,0.8],"y":[0,0,0]},"t":26,"s":[100,100,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.8,0.8,0.8],"y":[0,0,0]},"t":39,"s":[80,80,100]},{"i":{"x":[0.2,0.2,0.2],"y":[1,1,1]},"o":{"x":[0.8,0.8,0.8],"y":[0,0,0]},"t":54,"s":[90,90,100]},{"t":67,"s":[100,100,100]}],"ix":6}},"ao":0,"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"cart Outlines 2","parent":4,"td":1,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":11,"s":[0]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":25,"s":[-15]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":38,"s":[-15]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":54,"s":[13]},{"t":67,"s":[0]}],"ix":10},"p":{"a":0,"k":[-17.5,21.25,0],"ix":2},"a":{"a":0,"k":[46.5,85.25,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-3.881,0],[0,0],[0,0]],"o":[[0,0],[0.676,3.821],[0,0],[0,0],[0,0]],"v":[[-22.055,15.5],[-20.924,21.894],[-13.047,28.5],[26.245,28.5],[28.494,16.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[4.04,0],[0,0]],"o":[[0,0],[-0.493,-4.01],[0,0],[0,0]],"v":[[-25.721,-13.606],[-26.689,-21.477],[-34.629,-28.5],[-38.256,-28.5]],"c":false},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.721,-13.606],[-22.055,15.5]],"c":false},"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":38,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.034,-18.703],[37.732,-9.906],[35.829,8.331],[27.872,15.5],[-22.055,15.5]],"c":false}]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":51,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.927,-14.548],[38.625,-5.751],[36.722,12.486],[28.765,19.655],[-22.055,15.5]],"c":false}]},{"t":65,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.034,-18.703],[37.732,-9.906],[35.829,8.331],[27.872,15.5],[-22.055,15.5]],"c":false}]}],"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"tr","p":{"a":0,"k":[64.256,56.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":6,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 1","tt":2,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.3,"y":1},"o":{"x":0.7,"y":0},"t":36,"s":[66.5,-21.5,0],"to":[0,14,0],"ti":[0,-14,0]},{"t":45,"s":[66.5,62.5,0]}],"ix":2},"a":{"a":0,"k":[-5.5,-20.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[26,34],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":8,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-5.5,-20.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":-2,"op":46,"st":-2,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"circle Outlines 2","parent":4,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[-14,34,0],"ix":2},"a":{"a":0,"k":[50,98,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-2.393,0],[0,-2.393],[2.393,0],[0,2.393]],"o":[[2.393,0],[0,2.393],[-2.393,0],[0,-2.393]],"v":[[0,-4.332],[4.332,0],[0,4.332],[-4.332,0]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[50,98],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"circle Outlines","parent":4,"sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":11,"s":[22,34,0],"to":[0,-2.167,0],"ti":[0,0,0]},{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":25,"s":[22,21,0],"to":[0,0,0],"ti":[0,-2.167,0]},{"t":31,"s":[22,34,0]}],"ix":2},"a":{"a":0,"k":[86,98,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":31,"s":[{"i":[[-2.393,0],[0,-2.393],[2.393,0],[0,2.393]],"o":[[2.393,0],[0,2.393],[-2.393,0],[0,-2.393]],"v":[[0,-4.332],[4.332,0],[0,4.332],[-4.332,0]],"c":true}]},{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":38,"s":[{"i":[[-2.393,0],[0,-1.438],[2.393,0],[0,1.438]],"o":[[2.393,0],[0,1.438],[-2.393,0],[0,-1.438]],"v":[[0,-0.875],[4.332,1.729],[0,4.332],[-4.332,1.729]],"c":true}]},{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":47,"s":[{"i":[[-2.393,0],[0,-2.393],[2.393,0],[0,2.393]],"o":[[2.393,0],[0,2.393],[-2.393,0],[0,-2.393]],"v":[[0,-4.332],[4.332,0],[0,4.332],[-4.332,0]],"c":true}]},{"i":{"x":0.4,"y":1},"o":{"x":0.6,"y":0},"t":55,"s":[{"i":[[-2.393,0],[0,-1.438],[2.393,0],[0,1.438]],"o":[[2.393,0],[0,1.438],[-2.393,0],[0,-1.438]],"v":[[0,-0.875],[4.332,1.729],[0,4.332],[-4.332,1.729]],"c":true}]},{"t":64,"s":[{"i":[[-2.393,0],[0,-2.393],[2.393,0],[0,2.393]],"o":[[2.393,0],[0,2.393],[-2.393,0],[0,-2.393]],"v":[[0,-4.332],[4.332,0],[0,4.332],[-4.332,0]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0,0,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[86,98],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":241,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"cart Outlines","parent":4,"sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":11,"s":[0]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":25,"s":[-15]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":38,"s":[-15]},{"i":{"x":[0.3],"y":[1]},"o":{"x":[0.7],"y":[0]},"t":54,"s":[13]},{"t":67,"s":[0]}],"ix":10},"p":{"a":0,"k":[-17.5,21.25,0],"ix":2},"a":{"a":0,"k":[46.5,85.25,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-3.881,0],[0,0]],"o":[[0,0],[0.676,3.821],[0,0],[0,0]],"v":[[-22.055,15.5],[-20.924,21.894],[-13.047,28.5],[26.245,28.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[4.04,0],[0,0]],"o":[[0,0],[-0.493,-4.01],[0,0],[0,0]],"v":[[-25.721,-13.606],[-26.689,-21.477],[-34.629,-28.5],[-38.256,-28.5]],"c":false},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-25.721,-13.606],[-22.055,15.5]],"c":false},"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":38,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.034,-18.703],[37.732,-9.906],[35.829,8.331],[27.872,15.5],[-22.055,15.5]],"c":false}]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0},"t":51,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.927,-14.548],[38.625,-5.751],[36.722,12.486],[28.765,19.655],[-22.055,15.5]],"c":false}]},{"t":65,"s":[{"i":[[0,0],[0,0],[0.524,-5.019],[0,0],[4.096,0],[0,0]],"o":[[0,0],[5.025,-0.467],[0,0],[-0.426,4.074],[0,0],[0,0]],"v":[[-25.721,-13.606],[29.034,-18.703],[37.732,-9.906],[35.829,8.331],[27.872,15.5],[-22.055,15.5]],"c":false}]}],"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"st","c":{"a":0,"k":[0,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[64.256,56.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":6,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":17,"s":[86.5]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":31,"s":[100]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":47,"s":[100]},{"t":60,"s":[86.5]}],"ix":2},"o":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":17,"s":[-139]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":31,"s":[-159]},{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.8],"y":[0]},"t":47,"s":[-159]},{"t":60,"s":[-139]}],"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":241,"st":0,"bm":0}],"markers":[]};
  
  // Force sort dropdown options to be visible
  document.addEventListener('DOMContentLoaded', function() {
    const sortSelects = document.querySelectorAll('select[name="sort_by"], .sort-by select, .collection-sorting select, select.collection-sort, select[data-sort], #SortBy');
    
    sortSelects.forEach(function(select) {
      // Style the select element
      select.style.fontWeight = 'bold';
      select.style.color = '#000';
      
      // Style all options
      const options = select.querySelectorAll('option');
      options.forEach(function(option) {
        option.style.color = '#000';
        option.style.backgroundColor = '#fff';
        
        // Make selected option bold
        if (option.selected) {
          option.style.fontWeight = 'bold';
          option.style.backgroundColor = '#e6e6e6';
        } else {
          option.style.fontWeight = 'normal';
        }
      });
      
      // Update on change
      select.addEventListener('change', function() {
        options.forEach(function(option) {
          if (option.selected) {
            option.style.fontWeight = 'bold';
            option.style.backgroundColor = '#e6e6e6';
          } else {
            option.style.fontWeight = 'normal';
            option.style.backgroundColor = '#fff';
          }
        });
      });
    });
  });
  
  // ============================================
  // VARIANT POPUP FUNCTIONALITY - Global Scope
  // ============================================
  
  window.selectedVariantId = null;
  window.currentProduct = null;
  
  // Open variant popup
  window.openVariantPopup = function(productHandle) {
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        window.currentProduct = product;
        
        // Check if product has only one variant (no options to choose)
        if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
          // Add directly to cart without showing popup
          addToCartDirectly(product.variants[0].id);
          return;
        }
        
        // Show popup for products with variants
        displayProductInPopup(product);
        document.getElementById('variantPopup').style.display = 'flex';
        document.body.style.overflow = 'hidden';
      })
      .catch(error => {
        console.error('Error fetching product:', error);
        showQuickNotification('Αδυναμία φόρτωσης προϊόντος. Παρακαλώ δοκιμάστε ξανά.', 'error');
      });
  };
  
  // Add to cart directly without popup (AJAX)
  function addToCartDirectly(variantId) {
    // Show loading notification
    showQuickNotification('Προσθήκη στο καλάθι...', 'loading');
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      // Show success notification
      showQuickNotification('Προστέθηκε στο καλάθι με επιτυχία! ✓', 'success');
      
      // Update cart count using AJAX
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateCartCountDisplay(cart.item_count);
        });
      
      // Trigger cart update events
      if (typeof Shopify !== 'undefined' && typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate();
      }
      
      if (window.theme && typeof window.theme.updateCart === 'function') {
        window.theme.updateCart();
      }
      
      // Trigger custom event for cart drawer
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Open the side cart panel immediately
      openSideCart();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      showQuickNotification('Αδυναμία προσθήκης στο καλάθι. Παρακαλώ δοκιμάστε ξανά.', 'error');
    });
  }
  
  // Update cart count display
  function updateCartCountDisplay(count) {
    // Try multiple common cart count selectors
    const cartCountSelectors = [
      '.cart-count',
      '.cart-counter',
      '.cart__count',
      '.header__cart-count',
      '[data-cart-count]',
      '.js-cart-count',
      '#cart-count',
      '.cartcount'
    ];
    
    cartCountSelectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.textContent = count;
        if (count > 0) {
          element.classList.add('active');
        }
      });
    });
  }
  
  // Open side cart panel
  function openSideCart() {
    // Try multiple common cart drawer/panel selectors
    const cartPanelSelectors = [
      '.mini-cart',
      '.mini_cart',
      '.cart-drawer',
      '.cart-panel',
      '.side-cart',
      '.ajax-cart',
      '#mini-cart',
      '#cart-drawer',
      '[data-cart-drawer]',
      '.js-cart-drawer',
      '.popup-ajax-cart'
    ];
    
    // Try to find and open the cart panel
    let cartOpened = false;
    
    cartPanelSelectors.forEach(selector => {
      const cartElement = document.querySelector(selector);
      if (cartElement) {
        // Add common "open" classes
        cartElement.classList.add('open', 'active', 'is-open', 'show');
        cartElement.style.display = 'block';
        cartElement.style.visibility = 'visible';
        cartOpened = true;
      }
    });
    
    // Also add class to body to indicate cart is open
    document.body.classList.add('cart-open', 'cart-drawer-open');
    
    // If cart wasn't found, try triggering click on cart icon to open it
    if (!cartOpened) {
      const cartIcons = document.querySelectorAll('.cart-icon, .header-cart, [data-cart-trigger], .js-cart-trigger, .cart-trigger');
      cartIcons.forEach(icon => {
        if (icon) {
          icon.click();
          cartOpened = true;
        }
      });
    }
    
    // Reload cart content via AJAX
    fetch('/cart?view=ajax')
      .then(response => response.text())
      .then(html => {
        const cartContainers = document.querySelectorAll('.js-cart-inner, .cart-items, [data-cart-items]');
        if (cartContainers.length > 0) {
          // Parse the HTML to extract cart content
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newCartContent = doc.querySelector('.js-cart-inner');
          
          if (newCartContent) {
            cartContainers.forEach(container => {
              container.outerHTML = newCartContent.outerHTML;
            });
          }
        }
      })
      .catch(error => {
        console.log('Cart content refresh skipped:', error);
        // If AJAX cart view doesn't exist, just trigger a page-level cart update
        if (typeof window.theme !== 'undefined' && typeof window.theme.cartDrawer !== 'undefined') {
          window.theme.cartDrawer.open();
        }
      });
  }
  
  // Show quick notification with Lottie animation
  function showQuickNotification(message, type) {
    // Remove existing notification
    const existing = document.querySelector('.quick-notification');
    if (existing) {
      existing.remove();
    }
    
    // For loading/success, show the white circle with Lottie animation
    if (type === 'loading' || type === 'success') {
      const notification = document.createElement('div');
      notification.className = `quick-notification quick-notification-${type}`;
      
      // Create white circle container
      const circleContainer = document.createElement('div');
      circleContainer.style.cssText = `
        width: 100px;
        height: 100px;
        background: #fff;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 8px 24px rgba(0,0,0,0.15);
      `;
      
      // Create Lottie animation container
      const lottieContainer = document.createElement('div');
      lottieContainer.id = 'add-to-cart-animation-' + Date.now();
      lottieContainer.style.cssText = `
        width: 80px;
        height: 80px;
      `;
      
      circleContainer.appendChild(lottieContainer);
      notification.appendChild(circleContainer);
      
      // Add styles to notification
      notification.style.cssText = `
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
        animation: scaleIn 0.3s ease;
      `;
      
      document.body.appendChild(notification);
      
      // Wait for Lottie library to load, then play animation
      const playAnimation = () => {
        if (typeof lottie !== 'undefined') {
          // Load Order Confirm animation
          fetch(window.orderConfirmAnimationPath || '/Order Confirm.json')
            .then(response => response.json())
            .then(data => {
              const anim = lottie.loadAnimation({
                container: lottieContainer,
                renderer: 'svg',
                loop: type === 'loading',
                autoplay: true,
                animationData: data
              });
            })
            .catch(error => {
              console.log('Loading Order Confirm animation failed, using fallback');
              // Fallback to embedded add to cart animation
              const anim = lottie.loadAnimation({
                container: lottieContainer,
                renderer: 'svg',
                loop: type === 'loading',
                autoplay: true,
                animationData: window.addToCartAnimationData
              });
            });
        } else {
          // Fallback if Lottie is not available
          lottieContainer.innerHTML = '<div style="font-size: 40px; display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">✓</div>';
        }
      };
      
      // Check if Lottie is loaded, otherwise wait a bit
      if (typeof lottie !== 'undefined') {
        playAnimation();
      } else {
        setTimeout(playAnimation, 100);
      }
      
      // Auto remove after animation completes (success only)
      if (type === 'success') {
        setTimeout(() => {
          notification.style.animation = 'scaleOut 0.3s ease';
          setTimeout(() => notification.remove(), 300);
        }, 3500); // Order confirm animation duration ~3 seconds
      }
    } else {
      // For error messages, show regular notification
      const notification = document.createElement('div');
      notification.className = `quick-notification quick-notification-${type}`;
      notification.textContent = message;
      
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #dc3545;
        color: #fff;
        padding: 15px 25px;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 600;
        z-index: 10000;
        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        animation: slideInRight 0.3s ease;
        font-family: 'Manrope', sans-serif;
      `;
      
      document.body.appendChild(notification);
      
      setTimeout(() => {
        notification.style.animation = 'slideOutRight 0.3s ease';
        setTimeout(() => notification.remove(), 300);
      }, 3000);
    }
  }
  
  // Close variant popup
  window.closeVariantPopup = function() {
    document.getElementById('variantPopup').style.display = 'none';
    document.body.style.overflow = '';
    window.selectedVariantId = null;
    window.currentProduct = null;
    document.getElementById('variantMessage').style.display = 'none';
  };
  
  // Display product in popup
  function displayProductInPopup(product) {
    const productImage = document.getElementById('variantProductImage');
    if (product.featured_image) {
      productImage.src = product.featured_image;
      productImage.alt = product.title;
    }
    
    document.getElementById('variantProductTitle').textContent = product.title;
    const price = (product.price / 100).toFixed(2);
    document.getElementById('variantProductPrice').textContent = `€${price}`;
    
    displayVariantOptions(product);
  }
  
  // Display variant options
  function displayVariantOptions(product) {
    const container = document.getElementById('variantOptionsContainer');
    container.innerHTML = '';
    
    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      window.selectedVariantId = product.variants[0].id;
      return;
    }
    
    const options = product.options;
    
    // Get available values for each option based on variant availability
    const availableOptionValues = {};
    
    product.variants.forEach(variant => {
      if (variant.available) {
        if (variant.option1) {
          if (!availableOptionValues[options[0].name]) {
            availableOptionValues[options[0].name] = new Set();
          }
          availableOptionValues[options[0].name].add(variant.option1);
        }
        if (variant.option2 && options[1]) {
          if (!availableOptionValues[options[1].name]) {
            availableOptionValues[options[1].name] = new Set();
          }
          availableOptionValues[options[1].name].add(variant.option2);
        }
        if (variant.option3 && options[2]) {
          if (!availableOptionValues[options[2].name]) {
            availableOptionValues[options[2].name] = new Set();
          }
          availableOptionValues[options[2].name].add(variant.option3);
        }
      }
    });
    
    options.forEach((option, optionIndex) => {
      if (option.name === 'Title') return;
      
      const optionGroup = document.createElement('div');
      optionGroup.className = 'variant-option-group';
      
      const label = document.createElement('label');
      label.className = 'variant-option-label';
      label.textContent = option.name + ':';
      optionGroup.appendChild(label);
      
      const valuesContainer = document.createElement('div');
      valuesContainer.className = 'variant-option-values';
      
      // Only show available option values
      const availableValues = availableOptionValues[option.name] || new Set();
      
      option.values.forEach(value => {
        // Only create button if this value is available in stock
        if (availableValues.has(value)) {
          const valueButton = document.createElement('button');
          valueButton.className = 'variant-option-value';
          valueButton.textContent = value;
          valueButton.dataset.option = optionIndex + 1;
          valueButton.dataset.value = value;
          
          valueButton.onclick = function() {
            selectVariantOption(this, optionIndex + 1);
          };
          
          valuesContainer.appendChild(valueButton);
        }
      });
      
      // Only add the option group if there are available values
      if (valuesContainer.children.length > 0) {
        optionGroup.appendChild(valuesContainer);
        container.appendChild(optionGroup);
      }
    });
    
    if (product.variants.length > 0) {
      const firstAvailableVariant = product.variants.find(v => v.available);
      if (firstAvailableVariant) {
        preselectVariantOptions(firstAvailableVariant);
      }
    }
  }
  
  // Preselect variant options
  function preselectVariantOptions(variant) {
    const optionButtons = document.querySelectorAll('.variant-option-value');
    
    if (variant.option1) {
      optionButtons.forEach(btn => {
        if (btn.dataset.option === '1' && btn.dataset.value === variant.option1) {
          btn.classList.add('selected');
        }
      });
    }
    if (variant.option2) {
      optionButtons.forEach(btn => {
        if (btn.dataset.option === '2' && btn.dataset.value === variant.option2) {
          btn.classList.add('selected');
        }
      });
    }
    if (variant.option3) {
      optionButtons.forEach(btn => {
        if (btn.dataset.option === '3' && btn.dataset.value === variant.option3) {
          btn.classList.add('selected');
        }
      });
    }
    
    window.selectedVariantId = variant.id;
    updateAddToCartButton();
  }
  
  // Select variant option
  function selectVariantOption(button, optionNumber) {
    const allOptionsInGroup = document.querySelectorAll(`.variant-option-value[data-option="${optionNumber}"]`);
    allOptionsInGroup.forEach(btn => btn.classList.remove('selected'));
    
    button.classList.add('selected');
    findMatchingVariant();
  }
  
  // Find matching variant
  function findMatchingVariant() {
    if (!window.currentProduct) return;
    
    const selectedOptions = {};
    const selectedButtons = document.querySelectorAll('.variant-option-value.selected');
    
    selectedButtons.forEach(btn => {
      selectedOptions['option' + btn.dataset.option] = btn.dataset.value;
    });
    
    const matchingVariant = window.currentProduct.variants.find(variant => {
      let matches = true;
      if (selectedOptions.option1 && variant.option1 !== selectedOptions.option1) matches = false;
      if (selectedOptions.option2 && variant.option2 !== selectedOptions.option2) matches = false;
      if (selectedOptions.option3 && variant.option3 !== selectedOptions.option3) matches = false;
      return matches;
    });
    
    if (matchingVariant) {
      window.selectedVariantId = matchingVariant.id;
      
      const price = (matchingVariant.price / 100).toFixed(2);
      document.getElementById('variantProductPrice').textContent = `€${price}`;
      
      if (matchingVariant.featured_image) {
        document.getElementById('variantProductImage').src = matchingVariant.featured_image.src;
      }
      
      updateAddToCartButton(matchingVariant.available);
    } else {
      window.selectedVariantId = null;
      updateAddToCartButton(false);
    }
  }
  
  // Update add to cart button
  function updateAddToCartButton(available = true) {
    const button = document.getElementById('addToCartBtn');
    if (window.selectedVariantId && available) {
      button.disabled = false;
      button.textContent = 'Προσθήκη στο Καλάθι';
    } else if (!available) {
      button.disabled = true;
      button.textContent = 'Εξαντλημένο';
    } else {
      button.disabled = true;
      button.textContent = 'Επιλέξτε Μέγεθος';
    }
  }
  
  // Add to cart from popup
  window.addSelectedVariantToCart = function() {
    if (!window.selectedVariantId) {
      showVariantMessage('Παρακαλώ επιλέξτε όλες τις επιλογές', 'error');
      return;
    }
    
    const button = document.getElementById('addToCartBtn');
    button.disabled = true;
    button.textContent = 'Προσθήκη...';
    
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: window.selectedVariantId,
        quantity: 1
      })
    })
    .then(response => response.json())
    .then(data => {
      showVariantMessage('Προστέθηκε στο καλάθι με επιτυχία! ✓', 'success');
      
      // Update cart count using AJAX
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          updateCartCountDisplay(cart.item_count);
        });
      
      // Trigger cart update events
      if (typeof Shopify !== 'undefined' && typeof Shopify.onCartUpdate === 'function') {
        Shopify.onCartUpdate();
      }
      
      if (window.theme && typeof window.theme.updateCart === 'function') {
        window.theme.updateCart();
      }
      
      // Trigger custom event for cart drawer
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      // Open the side cart panel immediately
      setTimeout(() => {
        openSideCart();
        window.closeVariantPopup();
      }, 1000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      showVariantMessage('Αδυναμία προσθήκης στο καλάθι. Παρακαλώ δοκιμάστε ξανά.', 'error');
      button.disabled = false;
      button.textContent = 'Προσθήκη στο Καλάθι';
    });
  };
  
  // Show message
  function showVariantMessage(message, type) {
    const messageDiv = document.getElementById('variantMessage');
    messageDiv.textContent = message;
    messageDiv.className = 'variant-message ' + type;
    messageDiv.style.display = 'block';
    
    if (type === 'error') {
      setTimeout(() => {
        messageDiv.style.display = 'none';
      }, 3000);
    }
  }
  
  // Event listeners
  document.addEventListener('click', function(event) {
    const popup = document.getElementById('variantPopup');
    if (event.target === popup) {
      window.closeVariantPopup();
    }
  });
  
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      const popup = document.getElementById('variantPopup');
      if (popup && popup.style.display === 'flex') {
        window.closeVariantPopup();
      }
    }
  });
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
    jQuery(document).ready(function ($) {
        $('.btn-close').on('click', function(){
        $(this).parents('.parent-close').slideUp();
        })
    });

  } catch(e) { console.error(e); }
})();
})();
